import { tariffSchema } from '@billing/validation/tariff';
import type { Province } from '@billing/validation/payor';

export interface Tariff {
  id: string;
  code: string;
  prefix: number;
  description: string;
  effectiveDate: string;
  specialtyCode: string;
  province: Province;
  type: string;
  rate: string;
  anesthesiaServiceValue?: string;
  applyLocationModifier?: boolean;
  units?: number | null;
  icd9?: string | null;
  originalRate?: string;
  percentage?: number | null;
  split?: string | null;
  incision?: string | null;
  anesthesiaUnits?: number | null;
  total?: number;
  isManualTotal?: boolean;
  serviceStart?: string | null;
  serviceEnd?: string | null;
  status: string;
  lastSubmittedAt?: string | null;
  submissionDates?: string[];
  latestComment?: string | null;
  pendingComment?: string;
}

export interface AllTariffSearchResult {
  code: string;
  tariffs: Tariff[];
}

export type FormTariff = Omit<Tariff, 'id'>;

export const isTariff = (obj: any): obj is Tariff => {
  return tariffSchema.safeParse(obj).success;
};
